import { Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { Trans, useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { ENV_VARS } from "../../../config/env.ts";
import RouterConstants from "../../../constants/RouterConstants.ts";
import ConfirmationPopup from "../../common/ConfirmationPopup/ConfirmationPopup.tsx";
import styles from "./AnonymousUsageLimitPopup.module.scss";

interface AnonymousUsageLimitPopupProps {
	open: boolean;
	onClose: () => void;
}

const AnonymousUsageLimitPopup = ({ open, onClose }: AnonymousUsageLimitPopupProps) => {
	const { t } = useTranslation("common", { keyPrefix: "popups.anonymousUsageLimit" });
	const location = useLocation();

	const handleSignUp = () => {
		const continueUrl = encodeURIComponent(location.pathname);
		window.location.href = `${RouterConstants.SIGNUP.path}?continueUrl=${continueUrl}`;
	};

	const handleSignIn = () => {
		const newPlatformUrl = ENV_VARS.VITE_NEW_PLATFORM_URL ?? "";
		if (newPlatformUrl) {
			const returnUrl = encodeURIComponent(window.location.href);
			window.location.href = `${newPlatformUrl}/login?returnUrl=${returnUrl}`;
		}
	};

	return (
		<ConfirmationPopup
			paperClassName={styles.anonymousUsageLimitPopup}
			open={open}
			onClose={onClose}
			title={t("title")}
			description={
				<Typography className={styles.description}>
					<Trans t={t} i18nKey="description" components={{ strong: <strong /> }} />
				</Typography>
			}
			confirmButtonText={t("signUp")}
			onClick={handleSignUp}
			firstButtonText={t("signIn")}
			onSecondaryClick={handleSignIn}
		/>
	);
};

export default observer(AnonymousUsageLimitPopup);
